"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _theme = require("../theme");
var _system = require("@mui/system");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BlockRowStyled = (0, _system.styled)('div')({
  alignItems: 'center',
  backgroundColor: _theme.colors.surface,
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  height: 60,
  marginBottom: 5,
  boxShadow: "0 1px 2px rgb(0 0 0 / 15%)",
  '&:hover': {
    filter: "brightness(97%)"
  }
});

/**
 * 
 * @param {*} props 
 * @returns 
 */
var BlockRow = function BlockRow(props) {
  var style = _objectSpread({
    borderLeft: props.selected && "5px solid ".concat(_theme.colors.skyBlue)
  }, props.style);
  return /*#__PURE__*/_react["default"].createElement(BlockRowStyled, (0, _extends2["default"])({}, props, {
    style: style
  }), props.children);
};
var _default = exports["default"] = BlockRow;